import { render, staticRenderFns } from "./pcabout.vue?vue&type=template&id=143bc016"
import script from "./pcabout.vue?vue&type=script&lang=js"
export * from "./pcabout.vue?vue&type=script&lang=js"
import style0 from "./pcabout.vue?vue&type=style&index=0&id=143bc016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports